import React, { useRef } from 'react'

export type ContentEditableProps = {
  children: React.ReactNode
  value: string
  onChange: (value: string) => void
  onValidate?: (value: string) => boolean
}
export const ContentEditable = ({ children, value, onChange, onValidate }: ContentEditableProps) => {
  const editableRef = useRef<HTMLDivElement>(null)
  const reset = () => {
    if (editableRef.current) {
      editableRef.current.innerText = value.toString()
    }
  }
  const handleBlur = () => {
    const value = editableRef.current?.innerText.trim()
    let isValid = true
    if (onValidate) isValid = onValidate(value)

    if (!isValid) {
      return reset()
    } else {
      onChange(value)
    }
  }
  const handleFocus = () => {
    const el = editableRef.current
    if (!el) return

    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(el)
    selection?.removeAllRanges()
    selection?.addRange(range)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      editableRef.current?.blur()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      reset()
      editableRef.current?.blur()
    }
  }

  return (
    <div
      ref={editableRef}
      contentEditable={true}
      suppressContentEditableWarning={true}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      className="border-bottom border-2"
      style={{
        textAlign: 'center',
        userSelect: 'text',
      }}
    >
      {children}
    </div>
  )
}
